import { Dialog, DialogContent, Typography } from "@mui/material";


export const About = ({ version, lastUpdated, handleAboutClose }) => {

  return (
    <Dialog 
      open={true} 
      onClose={handleAboutClose}
      fullWidth={true}
      maxWidth="sm"
      style={{overflow: 'hidden'}}
    >
      <DialogContent style={{minHeight: 400, overflow: 'hidden'}}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <img src={process.env.PUBLIC_URL + '/img/ssd_logomark_primary.png'} alt="subsurface dynamics" style={{width: 120}}></img>
          <img src={process.env.PUBLIC_URL + '/img/athenaxssd_logo_blue.png'} alt="" style={{width: 40}}></img>
        </div>
        
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: 400, overflow: 'hidden'}}>
          <Typography variant="h5" noWrap>
            <b>SSD Automation</b>
          </Typography>
          <Typography component="div">
            Software version: {version}
          </Typography>
          <Typography component="div">
            Last updated: {lastUpdated}
          </Typography>

          <Typography style={{position: 'absolute', textAlign: 'center', bottom: 20, fontSize: 14}}>© 2024 Subsurface Dynamics Inc. All rights reserved.</Typography>
        </div>

      </DialogContent>
    </Dialog>
  );
};